import { render, staticRenderFns } from "./MyTeamSecond.vue?vue&type=template&id=2b6f6e7f&"
import script from "./MyTeamSecond.vue?vue&type=script&lang=js&"
export * from "./MyTeamSecond.vue?vue&type=script&lang=js&"
import style0 from "./MyTeamSecond.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports